export default () => {
	$('button[id^="accordion-"]').each( function(i) {   
        const id = $(this).attr('data-id');     
		const item = $('#accordion-content-'+id)
		const accordionIcon = $('#accordion-icon-'+id)
		$(this).on("click", function() {
			if(item.is(':hidden')) {
				accordionIcon.addClass('rotate-45')
				item.slideDown()
			} else {
				item.slideUp()
				accordionIcon.removeClass("rotate-45")
			}
		})
		
	});
}